export class IntelligenceProxyDataDto
{
    investorId: number
    votingPolicy: string 
    votingRecord: string
    policyHighlight: string
}